import { render, staticRenderFns } from "./gcb.vue?vue&type=template&id=5df0c392"
import script from "./gcb.vue?vue&type=script&lang=js"
export * from "./gcb.vue?vue&type=script&lang=js"
import style0 from "./gcb.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/gcb.vue
// module id = Io0f
// module chunks = 0